import React from 'react';
import Leaderboard from './Leaderboard';
import { IState } from '../state/State'
import { connect } from 'react-redux';
import * as StatsActions from '../actions/StatsActions'
import PerYearLeaderboard from './PerYearLeaderboard';
import RelationshipLeaderboard from './RelationshipLeaderboard';
import PerYearAndMonthLeaderboard from './PerYearAndMonthLeaderboard';
import GlobeMap from './charts/GlobeMap';
import YearlyRadarChart from './charts/YearlyRadarChart';

export interface IStatsBodyProps {
  topNNotechartArtists: Array<StatsActions.IUserRankingType>,
  topNPlayers: Array<StatsActions.IUserRankingType>,
  topNScores: Array<StatsActions.IUserRankingType>
  topNChartsPerYearAndMonth: Array<StatsActions.IPerYearAndMonthRankingsType>
  topNSongsPerYearAndMonth: Array<StatsActions.IPerYearAndMonthRankingsType>
  userScoresTaken: Array<StatsActions.IRelationshipRankingsType>
  topNPlaysPerCountry: Array<StatsActions.ICountryRankingType>
}

const StatsBody: React.FC<IStatsBodyProps> = (props: IStatsBodyProps) => {
    let board1: Array<[string, number]> = [];
    let board2: Array<[string, number]> = [];
    let board3: Array<[string, number]> = [];
    props.topNScores.forEach(s => board1.push([s.userName, s.count]));
    props.topNPlayers.forEach(p => board2.push([p.userName, p.count]));
    props.topNNotechartArtists.forEach(a => board3.push([a.userName, a.count]));

    let title = "Rhythm Horizon plays by country";
    return (
      <div>
        <table className="StatsBody">
          <tr>
            <td><Leaderboard title="NUMBER OF TOP 10 SCORES" stringHeader="Player" numberHeader="Scores" data={board1} /></td>
            <td><Leaderboard title="NUMBER OF PLAYS" stringHeader="Player" numberHeader="Plays" data={board2} /></td>
            <td><Leaderboard title="NUMBER OF CHARTS" stringHeader="Player" numberHeader="Charts" data={board3} /></td>
          </tr>
        </table>
        <div>
          <PerYearAndMonthLeaderboard id="TopPlayedChartsPerYearAndMonthSortedBarChart" title="TOP PLAYED CHARTS EACH MONTH" data={props.topNChartsPerYearAndMonth} />
          <PerYearAndMonthLeaderboard id="TopPlayedSongsPerYearAndMonthSortedBarChart" title="TOP PLAYED SONGS EACH MONTH" data={props.topNSongsPerYearAndMonth} />
          <RelationshipLeaderboard id="UserScoresTakenRelationshipLeaderboard" title="SCORES TAKEN BY USERS" data={props.userScoresTaken} />
          <GlobeMap id="TestGlobeMap" title={title} data={props.topNPlaysPerCountry} />
        </div>
      </div>
    );
  }
  
  const mapStateToProps = (state: IState) => ({
    topNNotechartArtists: state.topNNotechartArtistsLeaderboard.results,
    topNPlayers: state.topNPlaysLeaderboard.results,
    topNScores: state.topNScoresLeaderboard.results,
    topNChartsPerYearAndMonth: state.topNChartsPerYearAndMonthLeaderboard.results,
    topNSongsPerYearAndMonth: state.topNSongsPerYearAndMonthLeaderboard.results,
    userScoresTaken: state.userScoresTakenLeaderboard.results,
    topNPlaysPerCountry: state.topNPlaysPerCountryLeaderboard.results,
  });
  
  export default connect(mapStateToProps)(StatsBody);